import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ActionIndex.css';

export default class ActionIndex extends Component {
  static propTypes = {
    lines: PropTypes.array,
  }

  render() {
    const { lines } = this.props;

    return (
      <section className="action-index">
        {lines.map((line, i) =>
          <p key={i} dangerouslySetInnerHTML={{ __html: line }} />
        )}
      </section>
    );
  }
}
